import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardTitle, Table } from 'reactstrap'
import ApiService from '../../../data/services/ApiService'

const money = value => Number(value || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })

const PricingPreview = ({ productId }) => {
    const [configurations, setConfigurations] = useState([])
    const [error, setError] = useState('')

    useEffect(() => {
        if (!productId) return
        ApiService.getProductPricingPreview(productId)
            .then(response => setConfigurations(response.data.configurations || []))
            .catch(requestError => setError(requestError.response?.data?.message || 'No se pudo calcular la vista previa de precios'))
    }, [productId])

    return (
        <Card>
            <CardBody>
                <CardTitle>Vista previa de precios configurados</CardTitle>
                <p className="text-muted">Estos importes se calculan desde PrintPrices y el factor heredado de la categoría. Los precios guardados en variantes son datos históricos.</p>
                {error && <div className="alert alert-danger">{error}</div>}
                {!error && configurations.length === 0 && <div className="alert alert-warning">No hay configuraciones de precio aplicables a las medidas del producto.</div>}
                {configurations.length > 0 && (
                    <Table responsive striped>
                        <thead><tr><th>Medida</th><th>Material</th><th>Base</th><th>Factor</th><th>Ganancia artista</th><th>Precio público</th></tr></thead>
                        <tbody>
                            {configurations.map((item, index) => (
                                <tr key={`${item.size}-${item.material}-${index}`}>
                                    <td>{item.size}</td><td>{item.material}</td><td>{money(item.baseItemPrice)}</td>
                                    <td>{Number(item.artistPriceFactor).toFixed(2)}×</td><td>{money(item.artistEarningsPerUnit)}</td><td>{money(item.retailPrice)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </CardBody>
        </Card>
    )
}

export default PricingPreview
